import TutorialPage from "./tutorial-page"

export const QuizStudentTutorialPage = () => {

    return (
        <TutorialPage variant='quiz-student'/>
    )

}